export default __webpack_public_path__ + "static/2-eac6e461a62ba90e846d0bb6d4ca3cdd.jpg";